import React, { useEffect, useState, useLayoutEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoDark from "../../../assets/images/logo-dark.png";
import moment from "moment";

const PrintDoc = ({ innerRef, item }) => {
    const [subTot, setSubTot] = useState(0);
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const subTotal = (items) => {
    let subTotal = 0;

    if (items === undefined || items === null) {
      return subTotal;
    } else {
      items.forEach((el) => {
        subTotal = subTotal + el.amount;
      });

      return subTotal;
    }
  };

  useEffect(()=>{
    if (item !== undefined && item !== null) {
      setSubTot(subTotal(item.items));
    }

  },[item])
  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <Card>
          <Col lg={12}>
            <CardHeader className="border-bottom-dashed p-4">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                  {/* <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" /> */}
                  <div className="mt-sm-3 mt-3">
                    <h6 className="text-uppercase fw-semibold">{item.client && item.client.label}</h6>
                    <p className="mb-1">{item.company && item.company.label}</p>
                    <p className="mb-1">{item.department && item.department.label}</p>
                    {/* <h6 className="text-uppercase fw-semibold">{info.purchase_company && info.purchase_company.name}</h6>
                    <p className="mb-1">{info.purchase_department && info.purchase_department.name}</p> */}
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardBody className="p-4">
              <Row className="g-3">
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                  <h5 className="fs-14 mb-0">
                    #<span id="invoice-no">{item.transaction_no}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                  <h5 className="fs-14 mb-0">
                    <span id="invoice-date">{handleValidDate(item.transactionat)}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                  <h5 className="fs-14 mb-0">
                    <span id="invoice-date">{handleValidDate(item.dueat)}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                  <h5 className="fs-14 mb-0">
                    <span id="total-amount">{currencyFormat(subTot)}</span>
                  </h5>
                </Col>
              </Row>
            </CardBody>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                  <thead>
                    <tr className="table-active">
                      <th scope="col" style={{ width: "50px" }}>
                        #
                      </th>
                      <th scope="col">Detail Produk</th>
                      <th scope="col">Rate</th>
                      <th scope="col">Quantity</th>
                    </tr>
                  </thead>
                  <tbody id="products-list">
                    {(item.items || []).map((o, i) => {
                      return (
                        <tr key={i} id={i} className="product">
                          <th scope="row" className="product-id">
                            {i + 1}
                          </th>
                          <td className="text-start">{item.items[i].item.label}</td>
                          <td>{currencyFormat(item.items[i].price)}</td>
                          <td>{item.items[i].quantity}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <div className="mt-4">
                <div className="alert alert-info">
                  <p className="mb-0">
                    <span className="fw-semibold">NOTES:</span>
                    <span id="note"> {item.description}</span>
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <div>
                  <p className="mb-0">{item.user}</p>
                </div>
              </div>
            </CardBody>
          </Col>
        </Card>
      </div>
    </div>
  );
};

export default PrintDoc;
